/**
 * The link that opens a browser sign-in's window (Sign in once, S5, 2026-10-04): `/integrations?signin=<slug>`.
 *
 * The notice a person gets when a sign-in in Prest0n's browser truly ends (functions/src/prest0nSession/
 * signinLapseNotice.ts) carries it, in the email's button and on the bell row. The Integrations page reads it once its
 * list of sign-ins has loaded, and reopens that sign-in through the one resume door (connectCustomFlow.
 * resumeCustomSignIn); a slug its list does not hold leaves the page as it is. Pure; imports nothing.
 */

export const SIGNIN_LINK_PARAM = 'signin';

const SLUG_RE = /^custom-[A-Za-z0-9_-]{1,120}$/;

/** The sign-in a link names, or null (no parameter, or not a browser sign-in's slug). */
export function signinLinkSlug(search: string | null | undefined): string | null {
  if (!search) return null;
  let raw: string | null = null;
  try {
    raw = new URLSearchParams(search).get(SIGNIN_LINK_PARAM);
  } catch {
    return null;
  }
  const slug = typeof raw === 'string' ? raw.trim() : '';
  return SLUG_RE.test(slug) ? slug : null;
}

/** The page's own address without the link's parameter (every other parameter and the hash kept). */
export function withoutSigninLink(href: string): string {
  try {
    const u = new URL(href, 'https://prest0.ai');
    u.searchParams.delete(SIGNIN_LINK_PARAM);
    const q = u.searchParams.toString();
    return `${u.pathname}${q ? `?${q}` : ''}${u.hash}`;
  } catch {
    return '/integrations';
  }
}

/** The path a bell row for a sign-in links to, or null when the slug is not a browser sign-in's. */
export function signinLinkPath(slug: unknown): string | null {
  const s = typeof slug === 'string' ? slug.trim() : '';
  return SLUG_RE.test(s) ? `/integrations?${SIGNIN_LINK_PARAM}=${encodeURIComponent(s)}` : null;
}
